module.exports = __webpack_public_path__ + "img/co2_ikonica.e5195e0b.svg";